import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { PncpBiddingDetailProvider } from './context/pncp-bidding-detail-context';
import { PncpBiddingDetailComponent } from './pncp-bidding-detail-component';

export function PncpBiddingDetailFactory() {
  return (
    <BaseLayoutFactory>
      <PncpBiddingDetailProvider>
        <PncpBiddingDetailComponent />
      </PncpBiddingDetailProvider>
    </BaseLayoutFactory>
  );
}
